<ui-button
    text="Open dialog"
    (click)="showAlert()">
</ui-button>
